import { i18nextContainer } from 'shared/configs/i18n/config'

export const getCurrentDateTime = () => {
  const now = new Date()
  const hours = now.getHours().toString().padStart(2, '0')
  const minutes = now.getMinutes().toString().padStart(2, '0')
  return {
    date: new Intl.DateTimeFormat(i18nextContainer.language, {
      weekday: 'long',
      day: '2-digit',
      month: 'long'
    }).format(now),
    time: `${hours}:${minutes}`
  }
}
